import React, { Component } from 'react';
import styled from 'styled-components';
import {fonts, mediaQueries} from '../shared/config'
import InfluentialSneakerContent from './InfluentialSneakerContent';

export default function GoodForOutsole(props) {
    console.log(props.data);
    let sneakerContent = [];
    let odd = 1;
    let counter = 2+3;
    if (props.data != null) {
        console.log(props.data);
    for (var i = 0; i < props.data.length; i++) {
      if (i == 0)
        continue;
      else {
        if (i == counter) {
          if (odd){
            sneakerContent.push(<InfluentialSneakerContent headerPos="left" sneakerName={props.data[i-2].content} sneakerImgURL={props.data[i].image_link} credits={props.data[i].image_credits} text={props.data[i-1].content}/>)
            odd = 0;
            counter+=3
          }
          else if (!odd){
            sneakerContent.push(<InfluentialSneakerContent headerPos="right" sneakerName={props.data[i-2].content} sneakerImgURL={props.data[i].image_link } credits={props.data[i].image_credits} text={props.data[i-1].content}/>)
            odd = 1;
            counter+=3;
          }
          
        }
         
      }
    }
  }
    return (
        <div>
        {sneakerContent.map(block=> {
            return (block);
        })}
        </div>
    )
}